import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DeleteOrganisationModal } from 'src/app/components/settings/delete-organisation/delete-organisation.modal';
import { EditOrganisationModal } from 'src/app/components/settings/edit-organisation/edit-organisation.modal';
import { OrganisationInfoModel, IdsForSettingsService } from 'src/app/components/settings/ids-for-settings.service';
import { SettingsService } from 'src/app/components/settings/settings.service';
import { StandardIdModel } from 'src/app/models/api/standard-id.model';
import { IdentityOrganisationApiClient } from 'src/app/services/api-clients/identity-organisation.api-client';
import { LoggingService } from 'src/app/services/logging.service';

@Component({
  selector: 'app-organisationListItem',
  templateUrl: './organisationlistitem.component.html'
})
export class OrganisationListItemComponent implements OnInit {

  constructor(private modalService: NgbModal, private router: Router,
    private idsForSettingsService: IdsForSettingsService,
    private route: ActivatedRoute, private loggingService: LoggingService, private organisationApiClient: IdentityOrganisationApiClient, private settingService: SettingsService) {
    // Must not be empty. It's approved by a comment.
  }
  private _organisation!: any;
  organisationData!: any;
  whitelabelProviders: StandardIdModel[] = [];
  @Input('organisation') set organisation(val: any) {
    this._organisation = val;
    this.organisationApiClient.getOrganisation(val.guid).subscribe({
      next: (organisationData: any) => {
        this.organisationData = organisationData;
      }
    });
    this.organisationApiClient.getWhitelabelProviders(this.settingService.user.organisationGuid).subscribe(providers => {
      this.whitelabelProviders = providers;
    })
  }
  get organisation(): any {
    return this._organisation;
  }
  @Output() triggerRefresh = new EventEmitter();

  ngOnInit(): void {
    // Must not be empty. It's approved by a comment.
  }

  deleteOrganisation() {
    let ngbModalOptions: NgbModalOptions = {
      keyboard: false,
      centered: true,
      size: 'md',
      windowClass: 'dialog-bg-white'
    };
    const modalRef = this.modalService.open(DeleteOrganisationModal, ngbModalOptions);
    modalRef.componentInstance.organisationGuid = this.organisation.guid;
    modalRef.componentInstance.organisationName = this.organisation.name;
    modalRef.componentInstance.customerCount = this.organisationData.users.length;
    modalRef.closed.subscribe({
      next: (deleteSuccesfull) => {
        if (deleteSuccesfull !== true) {
          return;
        }
        // on succesfull delete bubble/emit the refresh up
        this.triggerRefresh.emit();
      }
    });
  }

  openOrganisationOverview() {
    this.idsForSettingsService.setSelectedOrganisation(new OrganisationInfoModel(this.organisation.guid, this.organisation.name))
    this.router.navigate(['/settings', 'organisation', this.organisation.guid, 'overview'], { relativeTo: this.route })
      .catch(error => {
        this.loggingService.logException(error);
      });
  }


  async editOrganisation() {
    if (this.modalService.hasOpenModals()) return;
    let ngbModalOptions: NgbModalOptions = {
      keyboard: false,
      centered: true,
      size: 'md',
      backdrop: 'static'
    };

    const modalRef = this.modalService.open(EditOrganisationModal, ngbModalOptions);
    (modalRef.componentInstance as EditOrganisationModal).whitelabelProviders = this.whitelabelProviders;
    (modalRef.componentInstance as EditOrganisationModal).useModalStandAlone = true;
    (modalRef.componentInstance as EditOrganisationModal).organisation = this.organisationData;
    (modalRef.componentInstance as EditOrganisationModal).oganisationUpdated.subscribe(async () => {
      this.triggerRefresh.emit();
    });
  }
}
